module.exports = __webpack_public_path__ + "media/images/top/img_interview_shunsuke00-1bdca2c21c58548f6c960eca517b28a4.jpg";